class WishlistBulkActions extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.itemIds = []

    this.optionVisibility()
  }

  setupListeners () {
    super.setupListeners()

    this.optionSelected = this.optionSelected.bind(this)
    this.checkboxChanged = this.checkboxChanged.bind(this)
    this.checkboxMimicChanged = this.checkboxMimicChanged.bind(this)

    this.els.options.element.addEventListener('change', this.optionSelected)

    window.addEventListener('wishlist-pages-loaded', () => {
      this.externalEls.checkbox?.elements.forEach(e => {
        e.addEventListener('change', this.checkboxChanged)
      })

      if (this.externalEls?.['checkbox-mimic']) {
        this.externalEls?.['checkbox-mimic'].elements.forEach(e => {
          e.addEventListener('change', this.checkboxMimicChanged)
        })
      }
    })

    this.addEventListener('mousedown', e => {
      if (this.itemIds.length > 0) {
        this.showError(false)
      } else {
        this.showError(true)
      }
    })
  }

  optionSelected (e) {
    switch (e.target.value) {
      case 'delete':
        this.deleteItems()
        break

      case 'add': {
        this.addItemsToCart()

        break
      }

      case 'delete-wishlist': {
        this.deleteWishlist()

        break
      }

      case 'delete-wishlist-share': {
        this.deleteWishlistShare()

        break
      }

      default:
        break
    }
  }

  async addItemsToCart () {
    if (!this.itemIds.length) {
      this.els.options.element.value = ''
      this.showError(true)
      return
    }

    this.showError(false)

    const items = this.externalEls.checkbox.elements
      .filter(el => this.itemIds.includes(el.value))
      .map(el => ({
        id: el.dataset.variantId,
        quantity: el.dataset.quantity,
      }))

    await window.BAO.Cart.addItem(items)
  }

  checkboxChanged (e) {
    this.externalEls?.['checkbox-mimic']?.elements.forEach(c => {
      if (c.value === e.target.value) {
        c.checked = e.target.checked
      }
    })

    if (e.target.checked) {
      this.itemIds.push(e.target.value)
      this.showError(false)
    } else {
      this.itemIds.pop(e.target.value)
    }

    this.optionVisibility()
  }

  checkboxMimicChanged (e) {
    this.externalEls.checkbox?.elements.forEach(c => {
      if (c.value === e.target.value) {
        c.checked = e.target.checked
      }
    })

    if (e.target.checked) {
      this.itemIds.push(e.target.value)
      this.showError(false)
    } else {
      this.itemIds.pop(e.target.value)
    }

    this.optionVisibility()
  }

  optionVisibility () {
    if (this.itemIds.length > 0) {
      this.querySelector('select').removeAttribute('disabled')
    } else {
      this.querySelector('select').setAttribute('disabled', 'disabled')
    }
  }

  async deleteItems () {
    if (!this.itemIds.length) {
      this.els.options.element.value = ''
      this.showError(true)
      return
    }

    this.showError(false)

    window.BAO.wishlist.genericModalHeading = this.deleteModalHeading
    window.BAO.wishlist.genericModalText = this.deleteModalText
    window.BAO.wishlist.genericModalCancelText = this.deleteModalCancelText
    window.BAO.wishlist.genericModalContinueText = this.deleteModalContinueText
    window.BAO.wishlist.openGenericModal()

    window.BAO.wishlist.genericModalContinue = async () => {
      await window.BAO.wishlist.removeItems(
        this.listId,
        this.itemIds.join(','),
        this.token,
      )

      window.location.reload()
    }

    window.BAO.wishlist.genericModalCancel = async () => {
      this.els.options.element.value = ''

      window.BAO.wishlist.closeGenericModal()
    }
  }

  async deleteWishlist () {
    window.BAO.wishlist.genericModalHeading = this.deleteListModalHeading
    window.BAO.wishlist.genericModalText = this.deleteListModalText
    window.BAO.wishlist.genericModalCancelText = this.deleteListModalCancelText
    window.BAO.wishlist.genericModalContinueText = this.deleteListModalContinueText
    window.BAO.wishlist.openGenericModal()

    window.BAO.wishlist.genericModalContinue = async () => {
      await window.BAO.wishlist.removeList(this.listId, this.token)

      window.location.href = window.theme.appSettings.proxyUrl
    }
  }

  async deleteWishlistShare () {
    window.BAO.wishlist.genericModalHeading = this.deleteListModalHeading
    window.BAO.wishlist.genericModalText = this.deleteListModalTextShare
    window.BAO.wishlist.genericModalCancelText = this.deleteListModalCancelText
    window.BAO.wishlist.genericModalContinueText = this.deleteListModalContinueText
    window.BAO.wishlist.openGenericModal()

    window.BAO.wishlist.genericModalContinue = async () => {
      await window.BAO.wishlist.removeList(this.listId, this.token)

      window.location.href = window.theme.appSettings.proxyUrl
    }
  }

  async showError (state) {
    const errorClass = 'wlh-Actions-hasError'
    const actionsBar = this.externalEls['actions-bar']

    if (actionsBar) {
      if (
        (actionsBar.element.classList.contains(errorClass) && !state) ||
        (!actionsBar.element.classList.contains(errorClass) && state)
      ) {
        actionsBar.element.classList.toggle(errorClass)
      }
    }
  }

  get listId () {
    return this.dataset.listId
  }

  get token () {
    return window.BAO.wishlist.token
  }

  get deleteModalHeading () {
    return this.dataset.deleteModalHeading
  }

  get deleteModalText () {
    return this.dataset.deleteModalText
  }

  get deleteModalCancelText () {
    return this.dataset.deleteModalCancelText
  }

  get deleteModalContinueText () {
    return this.dataset.deleteModalContinueText
  }

  get deleteListModalHeading () {
    return this.dataset.deleteListModalHeading
  }

  get deleteListModalText () {
    return this.dataset.deleteListModalText
  }

  get deleteListModalTextShare () {
    return this.dataset.deleteListModalTextShare
  }

  get deleteListModalCancelText () {
    return this.dataset.deleteListModalCancelText
  }

  get deleteListModalContinueText () {
    return this.dataset.deleteListModalContinueText
  }
}

customElements.define('wishlist-bulk-actions', WishlistBulkActions)
